/***
 * File name: implementation.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Implementation of
 * Security Measures / Controls tab in the Personal Data Breach Notification Form
 *
 * This file defines all the input fields needed for the Implementation of
 * Security Measures tab
 *
 */
import implem from '@/assets/implem.png'
export default function (vm) {
  const isNoImplemYet = () => {
    const enabled = [
      'fullReportCheckbox',
      'privacyImpactAssessmentCheckbox',
      'securityIncidentManagementPolicyCheckbox',
      'operationsSecurityCheckbox',
      'systemAcquisitionCheckbox',
      'accessControlCheckbox',
      'communicationsSecurityCheckbox',
      'physicalAndEnvironmentalSecurityCheckbox',
      'cryptographyCheckbox',
      'assetManagementCheckbox',
      'cryptograhpyCheckbox',
      'humanResourceSecurityCheckbox',
      'complianceCheckbox',
      'informationSecurityPolicyCheckbox',
      'dataSubjectNotificationCheckbox',
      'delayInNotificationExplanationCheckbox',
      'othersAttachmentCheckbox'
    ]
    return vm.operation === 'view' && !enabled.some(x => vm.formItem[`${x}`])
  }

  const noImplemYet = [
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'NoDataYet',
              formKey: 'NoDataYet',
              vBind: {
                image: implem,
                message: 'You haven’t selected  any Implementation of Security Measures / Controls yet. Please evaluate first.'
              }
            }
          ]
        }
      ]
    }
  ]
  const implemCheckboxes = [
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'fullReportCheckbox',
              vBind: {
                label: 'Full Report',
                dense: true,
                id: 'fullReportCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'privacyImpactAssessmentCheckbox',
              vBind: {
                label: 'Privacy Impact Assessment',
                dense: true,
                id: 'privacyImpactAssessmentCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'securityIncidentManagementPolicyCheckbox',
              vBind: {
                label: 'Security Incident Management Policy',
                dense: true,
                id: 'securityIncidentManagementPolicyCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    // header
    {
      is: 'v-row',
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'h3',
              header: true,
              vText: 'Sections of the Privacy Manual containing controls/policies/measures on, if any:'
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'operationsSecurityCheckbox',
              vBind: {
                label: 'Operations Security (Protection from malware; backup; logging and monitoring)',
                dense: true,
                id: 'operationsSecurityCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'systemAcquisitionCheckbox',
              vBind: {
                label: 'System Acquisition, Development & Maintenance (Security in Development and Support Processes)',
                dense: true,
                id: 'systemAcquisitionCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'accessControlCheckbox',
              vBind: {
                label: 'Access Control (User Responsibilities; System & Application Access Control)',
                dense: true,
                id: 'accessControlCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'communicationsSecurityCheckbox',
              vBind: {
                label: 'Communications Security (Network Security Management, Information Transfer)',
                dense: true,
                id: 'communicationsSecurityCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'physicalAndEnvironmentalSecurityCheckbox',
              vBind: {
                label: 'Physical and Environmental Security (e.g. Means of Storage, Security Measures, Form of Information Stored, Storage Type and Location)',
                dense: true,
                id: 'physicalAndEnvironmentalSecurityCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'assetManagementCheckbox',
              vBind: {
                label: 'Asset Management (Media Handling, Acceptable Use of Assets)',
                dense: true,
                id: 'assetManagementCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'cryptographyCheckbox',
              vBind: {
                label: 'Cryptography',
                dense: true,
                id: 'cryptographyCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'humanResourceSecurityCheckbox',
              vBind: {
                label: 'Human Resource Security (Information Awareness, Education & Training, Disciplinary Process)',
                dense: true,
                id: 'humanResourceSecurityCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'complianceCheckbox',
              vBind: {
                label: 'Compliance (Legal & Contractual Requirements – Cybercrime, Procedure for Reporting Malicious Attacks)',
                dense: true,
                id: 'complianceCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'informationSecurityPolicyCheckbox',
              vBind: {
                label: 'Information Security Policy for the Third-Party Service Provider;',
                dense: true,
                id: 'informationSecurityPolicyCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'dataSubjectNotificationCheckbox',
              vBind: {
                label: 'Copy of Data Subject Notification and its Proof of Sending',
                dense: true,
                id: 'dataSubjectNotificationCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'delayInNotificationExplanationCheckbox',
              vBind: {
                label: 'Explanation as to why there was delay in notification.',
                dense: true,
                id: 'delayInNotificationExplanationCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'v-checkbox',
              formKey: 'othersAttachmentCheckbox',
              vBind: {
                label: 'Others',
                dense: true,
                id: 'othersAttachmentCheckbox',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                change: (val) => {
                  if (val) vm.$set(vm.formItem, 'others', [''])
                  else vm.$set(vm.formItem, 'others', [])
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.othersAttachmentCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pt-0 pb-0 pl-8'
          },
          children: [
            {
              is: 'DynamicFileInput',
              formKey: 'others',
              vBind: {
                ref: 'dynamicFileInput',
                class: 'required-field',
                label: 'Others',
                dense: true,
                id: 'others',
                disabled: vm.readOnly,
                outlined: true,
                isDocumentSubmitted: vm.isDocumentSubmitted
              },
              vOn: {
                input: () => { vm.$v.formItem.others.$touch() },
                blur: () => { vm.$v.formItem.others.$touch() }
              }
            }
          ]
        }
      ]
    }
  ]
  const implemFiles = [
    {
      is: 'v-row',
      vShow: vm.formItem.fullReportCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'fullReportFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.fullReportFile,
                label: 'Full Report',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'fullReportFile',
                fieldName: 'fullReport',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.fullReportFile.$touch() },
                blur: () => { vm.$v.formItem.fullReportFile.$touch() },
                change: () => {
                  vm.$v.formItem.fullReportFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pt-0 pl-16'
          },
          children: [
            {
              is: 'h4',
              header: true,
              vText: 'Please include the items that are tagged as "no information yet" on the data breach notification details on the submitted full report.'
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.privacyImpactAssessmentCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'privacyImpactAssessmentFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.privacyImpactAssessmentFile,
                label: 'Privacy Impact Assessment',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'privacyImpactAssessmentFile',
                fieldName: 'privacyImpactAssessment',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.privacyImpactAssessmentFile.$touch() },
                blur: () => { vm.$v.formItem.privacyImpactAssessmentFile.$touch() },
                change: () => {
                  vm.$v.formItem.privacyImpactAssessmentFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.securityIncidentManagementPolicyCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'securityIncidentManagementPolicyFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.securityIncidentManagementPolicyFile,
                label: 'Security Incident Management Policy',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'securityIncidentManagementPolicyFile',
                fieldName: 'securityIncidentManagementPolicy',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.securityIncidentManagementPolicyFile.$touch() },
                blur: () => { vm.$v.formItem.securityIncidentManagementPolicyFile.$touch() },
                change: () => {
                  vm.$v.formItem.securityIncidentManagementPolicyFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    // header
    {
      is: 'v-row',
      vShow: vm.formItem.operationsSecurityCheckbox || vm.formItem.systemAcquisitionCheckbox || vm.formItem.accessControlCheckbox || vm.formItem.communicationsSecurityCheckbox || vm.formItem.physicalAndEnvironmentalSecurityCheckbox || vm.formItem.assetManagementCheckbox || vm.formItem.cryptographyCheckbox || vm.formItem.humanResourceSecurityCheckbox || vm.formItem.complianceCheckbox,
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'h3',
              header: true,
              vText: 'Sections of the Privacy Manual containing controls/policies/measures on, if any:'
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.operationsSecurityCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'operationsSecurityFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.operationsSecurityFile,
                label: 'Operations Security (Protection from malware; backup; logging and monitoring)',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'operationsSecurityFile',
                fieldName: 'operationsSecurity',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.operationsSecurityFile.$touch() },
                blur: () => { vm.$v.formItem.operationsSecurityFile.$touch() },
                change: () => {
                  vm.$v.formItem.operationsSecurityFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.systemAcquisitionCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'systemAcquisitionFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.systemAcquisitionFile,
                label: 'System Acquisition, Development & Maintenance (Security in Development and Support Processes)',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'systemAcquisitionFile',
                fieldName: 'systemAcquisition',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.systemAcquisitionFile.$touch() },
                blur: () => { vm.$v.formItem.systemAcquisitionFile.$touch() },
                change: () => {
                  vm.$v.formItem.systemAcquisitionFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.accessControlCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'accessControlFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.accessControlFile,
                label: 'Access Control (User Responsibilities; System & Application Access Control)',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'accessControlFile',
                fieldName: 'accessControl',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.accessControlFile.$touch() },
                blur: () => { vm.$v.formItem.accessControlFile.$touch() },
                change: () => {
                  vm.$v.formItem.accessControlFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.communicationsSecurityCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'communicationsSecurityFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.communicationsSecurityFile,
                label: 'Communications Security (Network Security Management, Information Transfer)',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'communicationsSecurityFile',
                fieldName: 'communicationsSecurity',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.communicationsSecurityFile.$touch() },
                blur: () => { vm.$v.formItem.communicationsSecurityFile.$touch() },
                change: () => {
                  vm.$v.formItem.communicationsSecurityFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.physicalAndEnvironmentalSecurityCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'physicalAndEnvironmentalSecurityFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.physicalAndEnvironmentalSecurityFile,
                label: 'Physical and Environmental Security (e.g. Means of Storage, Security Measures, Form of Information Stored, Storage Type and Location)',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'physicalAndEnvironmentalSecurityFile',
                fieldName: 'physicalAndEnvironmentalSecurity',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.physicalAndEnvironmentalSecurityFile.$touch() },
                blur: () => { vm.$v.formItem.physicalAndEnvironmentalSecurityFile.$touch() },
                change: () => {
                  vm.$v.formItem.physicalAndEnvironmentalSecurityFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.assetManagementCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'assetManagementFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.assetManagementFile,
                label: 'Asset Management (Media Handling, Acceptable Use of Assets)',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'assetManagementFile',
                fieldName: 'assetManagement',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.assetManagementFile.$touch() },
                blur: () => { vm.$v.formItem.assetManagementFile.$touch() },
                change: () => {
                  vm.$v.formItem.assetManagementFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.cryptographyCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'cryptographyFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.cryptographyFile,
                label: 'Cryptography',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'cryptographyFile',
                fieldName: 'cryptography',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.cryptographyFile.$touch() },
                blur: () => { vm.$v.formItem.cryptographyFile.$touch() },
                change: () => {
                  vm.$v.formItem.cryptographyFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.humanResourceSecurityCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'humanResourceSecurityFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.humanResourceSecurityFile,
                label: 'Human Resource Security (Information Awareness, Education & Training, Disciplinary Process)',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'humanResourceSecurityFile',
                fieldName: 'humanResourceSecurity',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.humanResourceSecurityFile.$touch() },
                blur: () => { vm.$v.formItem.humanResourceSecurityFile.$touch() },
                change: () => {
                  vm.$v.formItem.humanResourceSecurityFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.complianceCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-16'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'complianceFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.complianceFile,
                label: 'Compliance (Legal & Contractual Requirements – Cybercrime, Procedure for Reporting Malicious Attacks)',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'complianceFile',
                fieldName: 'compliance',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.complianceFile.$touch() },
                blur: () => { vm.$v.formItem.complianceFile.$touch() },
                change: () => {
                  vm.$v.formItem.complianceFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    // after indent
    {
      is: 'v-row',
      vShow: vm.formItem.informationSecurityPolicyCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'informationSecurityPolicyFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.informationSecurityPolicyFile,
                label: 'Information Security Policy for the Third-Party Service Provider;',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'informationSecurityPolicyFile',
                fieldName: 'informationSecurityPolicy',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.informationSecurityPolicyFile.$touch() },
                blur: () => { vm.$v.formItem.informationSecurityPolicyFile.$touch() },
                change: () => {
                  vm.$v.formItem.informationSecurityPolicyFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.dataSubjectNotificationCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'dataSubjectNotificationFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.dataSubjectNotificationFile,
                label: 'Copy of Data Subject Notification and its Proof of Sending',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'dataSubjectNotificationFile',
                fieldName: 'dataSubjectNotification',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.dataSubjectNotificationFile.$touch() },
                blur: () => { vm.$v.formItem.dataSubjectNotificationFile.$touch() },
                change: () => {
                  vm.$v.formItem.dataSubjectNotificationFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.delayInNotificationExplanationCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-8'
          },
          children: [
            {
              is: 'FileInputUpload',
              formKey: 'delayInNotificationExplanationFile',
              vBind: {
                inputClass: 'required-field',
                value: vm.formItem.delayInNotificationExplanationFile,
                label: 'Explanation as to why there was delay in notification.',
                dense: true,
                clearable: true,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                accept: '.pdf',
                fileId: 'delayInNotificationExplanationFile',
                fieldName: 'delayInNotificationExplanation',
                entryId: vm.id,
                collection: 'pdbnf',
                readonly: vm.readOnly,
                outlined: !vm.readOnly
              },
              vOn: {
                input: () => { vm.$v.formItem.delayInNotificationExplanationFile.$touch() },
                blur: () => { vm.$v.formItem.delayInNotificationExplanationFile.$touch() },
                change: () => {
                  vm.$v.formItem.delayInNotificationExplanationFile.$touch()
                }
              }
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.othersAttachmentCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pb-0 pl-11'
          },
          children: [
            {
              is: 'h3',
              header: true,
              vText: 'Others:'
            }
          ]
        }
      ]
    },
    {
      is: 'v-row',
      vShow: vm.formItem.othersAttachmentCheckbox,
      vBind: {
        class: 'pt-0'
      },
      children: [
        {
          is: 'v-col',
          vBind: {
            class: 'pt-0 pb-0 pl-8'
          },
          children: [
            {
              is: 'DynamicFileInput',
              formKey: 'othersAttachmentFile',
              vBind: {
                ref: 'dynamicFileInput',
                value: vm.formItem.othersAttachmentFile,
                canEdit: vm.canChange ? false : !vm.readOnly,
                showDownload: vm.readOnly,
                entryId: vm.id,
                readonly: vm.readOnly,
                outlined: !vm.readOnly,
                canUpload: true,
                othersLabels: vm.formItem.others,
                isDocumentSubmitted: vm.isDocumentSubmitted
              },
              vOn: {
                input: () => { vm.$v.formItem.othersAttachmentFile.$touch() },
                blur: () => { vm.$v.formItem.othersAttachmentFile.$touch() },
                change: () => {
                  vm.$v.formItem.othersAttachmentFile.$touch()
                }
              }
            }
          ]
        }
      ]
    }
  ]
  const noFilesStatus = [
    'Submitted', 'For Evaluation', 'Initial Review', 'Final Review',
    'For Evaluation - PBNEF', 'Initial Review - PBNEF', 'Final Review - PBNEF'
  ]
  const ret = noFilesStatus.includes(vm.status) ? (isNoImplemYet() ? noImplemYet : implemCheckboxes) : implemFiles
  return {
    tab: 3,
    label: 'Implementation of Security Measures / Controls',
    optionQuery: {
    },
    optionName: [],
    children: [
      {
        is: 'v-row',
        children: [{ is: 'v-col' }]
      },
      // header
      {
        is: 'v-row',
        children: [
          {
            is: 'v-col',
            children: [
              {
                is: 'LabelError',
                header: true,
                vText: 'Implementation of Security Measures / Controls',
                vBind: {
                  errorMessage: 'Please select at least one (1) Implementation of Security Measures / Controls',
                  showError: vm.implemError,
                  bind: {
                    style: 'color: #162b54'
                  }
                }
              }
            ]
          }
        ]
      },
      ...ret,
      // header
      {
        is: 'v-row',
        children: [
          {
            is: 'v-col',
            children: [
              {
                is: 'h2',
                header: true,
                vText: 'No. of Days required for Document Submission',
                vBind: {
                  style: 'color: #162b54'
                }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 3
            },
            children: [
              {
                is: 'DateComponent',
                formKey: 'startForDocumentSubmission',
                vBind: {
                  value: vm.formItem.startForDocumentSubmission,
                  label: 'Start Date',
                  dense: true,
                  noTitle: false,
                  wholeMonth: true,
                  placeholder: '----',
                  id: 'startForDocumentSubmission',
                  disabled: true,
                  outlined: true
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 3
            },
            children: [
              {
                is: 'DateComponent',
                formKey: 'endForDocumentSubmission',
                vBind: {
                  value: vm.formItem.endForDocumentSubmission,
                  label: 'End Date',
                  dense: true,
                  noTitle: false,
                  wholeMonth: true,
                  placeholder: '----',
                  id: 'endForDocumentSubmission',
                  disabled: true,
                  outlined: true
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 2
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'daysForDocumentSubmission',
                vBind: {
                  class: 'required-field mb-1',
                  label: 'Days',
                  dense: true,
                  id: 'daysForDocumentSubmission',
                  disabled: vm.readOnly || !vm.canUserEditField([{ userRole: 'evaluator', status: ['For Evaluation'] }, { userRole: 'reviewer', status: ['Initial Review', 'Final Review'] }]),
                  outlined: !vm.readOnly
                },
                vOn: {
                  input: () => { vm.$v.formItem.daysForDocumentSubmission.$touch() },
                  blur: () => { vm.$v.formItem.daysForDocumentSubmission.$touch() }
                }
              }
            ]
          }
        ]
      }
    ],
    formActions: []
  }
}
